/**
 * Help §5.0 — the page lead.
 *
 * Rendered as a navy hero rather than a numbered card: it is the guide's cover,
 * not a topic (it carries no number and is not listed among the 13 TOC topics —
 * same shape as the legacy guide, whose Welcome sat above the first group
 * divider). It still owns the standard `help-section-welcome` anchor/testid so
 * the section contract is uniform for the e2e suite.
 */
import { helpSectionElementId } from '../help-sections.js';

const ID = helpSectionElementId('welcome');

export function Welcome(): React.JSX.Element {
  return (
    <section
      id={ID}
      data-testid={ID}
      data-help-section="welcome"
      aria-labelledby={`${ID}-heading`}
      tabIndex={-1}
      className="scroll-mt-6 overflow-hidden rounded-lg bg-gradient-to-br from-primary to-primary-hover p-8 outline-none sm:p-10"
    >
      <span className="inline-block rounded-full bg-accent/15 px-3 py-1 text-[11px] font-semibold uppercase tracking-[0.14em] text-accent">
        User Guide
      </span>
      <h2
        id={`${ID}-heading`}
        className="brand-font mt-4 text-3xl font-bold leading-tight text-white sm:text-4xl"
      >
        Welcome to the EER&nbsp;App
      </h2>
      <p className="mt-4 max-w-2xl text-[17px] leading-relaxed text-slate-300">
        This guide shows you, step by step, how to use the platform — from an incoming role to
        managing your client directory and producing a ready-to-send package of recruiting
        documents.
      </p>
      <p className="mt-5 text-sm text-slate-400">
        Pick a topic from the list on the left, or search it by a word you remember.
      </p>
    </section>
  );
}
